import { render, staticRenderFns } from "./RecepcionGarantias.vue?vue&type=template&id=5c0182fa&scoped=true"
import script from "./RecepcionGarantias.vue?vue&type=script&lang=js"
export * from "./RecepcionGarantias.vue?vue&type=script&lang=js"
import style0 from "./RecepcionGarantias.vue?vue&type=style&index=0&id=5c0182fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0182fa",
  null
  
)

export default component.exports